import LeftSectionBlock from "../../components/LeftSectionBlock";
import RightSectionBlock from "../../components/RightSectionBlock";
import ResponsiveImageMapOrientation from "../../components/ResponsiveImageMapOrientation";
import OrientationImage from "../../assets/images/4-day-neo.svg";
import HoverBlock from "../../components/HoverBlock";
import Accordion from "../../components/Accordion";

const areas = [
  {
    shape: "circle",
    coords: "507,68,63",
    alt: "dayone",
    color: "rgba(0, 0, 255, 0)",
    className: "dayone-bubble-hover-blk",
  },
  {
    shape: "circle",
    coords: "700,133,128",
    alt: "daytwothree",
    color: "rgba(0, 0, 255, 0)",
    className: "daytwothree-bubble-hover-blk",
  },
  {
    shape: "circle",
    coords: "893,67,63",
    alt: "dayfour",
    color: "rgba(0, 0, 255, 0)",
    className: "dayfour-bubble-hover-blk",
  },
];

const sections = [
  {
    title: "Day 1",
    content: (
      <div className="content-accordion">
        <p>
          Day 1: Introduction to iCXeed Expert Essentials and our Innovation
          Values & DNA
          <br />
          <br />
          This day focuses on immersing new hires in our unique culture and core
          principles.
          <br />
          <br />
          We introduce our DNA and values, ensuring new experts understand what
          makes iCXeed different.
        </p>
      </div>
    ),
  },
  {
    title: "Day 2 & Day 3",
    content: (
      <div className="content-accordion">
        <p>
          Day 2-3: Deep dive into Business Process Innovation techniques and
          practices
        </p>
        <ul>
          <li>
            <p>
              These two days are dedicated to in-depth exploration of what
              Business Process Innovation is and how diversity drives
              innovation.
            </p>
          </li>
          <li>
            <p>
              We cover key concepts, tools, and best practices that form the
              foundation of our approach.
            </p>
          </li>
          <li>
            <p>
              Hands-on exercises and case studies help reinforce learning and
              practical application.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Day 4",
    content: (
      <div className="content-accordion">
        <p>Day 4: Application of learnings to client-specific challenges</p>

        <ul>
          <li>
            <p>
              The final day bridges theory and practice by applying new
              knowledge to real-world scenarios.
            </p>
          </li>
          <li>
            <p>
              This helps new experts contextualize their learning and prepares
              them for client engagements.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
];

const MainContent = () => {
  return (
    <>
      <div className="orientation-section-desktop-blk">
        <div className="orientation-section-blk">
          <ResponsiveImageMapOrientation
            src={OrientationImage}
            alt="orientation"
            mapName="orientation"
            areas={areas}
          />
        </div>
        <HoverBlock
          description="Hover days to reveal information"
          marginBottom="70px"
        />
      </div>
      <div className="orientation-section-mobile-blk">
        <img src={OrientationImage} />
        <Accordion sections={sections} />
      </div>
    </>
  );
};

const htmlBlurb = () => {
  return (
    <>
      At iCXeed, we understand that building true expertise takes time and
      dedicated effort. Our New Expert Orientation (NEO) is a carefully designed
      4-day program that serves as the foundation for immersing our experts in
      iCXeed's culture, methodologies, and approach to business process
      innovation.
      <br />
      <br /> We've structured this program to provide the right balance of
      information and practical application without overwhelming our new
      experts. Our experience has shown that four days is the optimal duration
      to introduce key concepts, foster engagement, and set the stage for
      continuous learning and growth.
    </>
  );
};

const NewExpertOrientationPage = () => {
  return (
    <div className="main-container-blk">
      <div className="main-section-blk">
        <LeftSectionBlock />
        <RightSectionBlock
          title="NEW EXPERT ORIENTATION"
          htmlBlurb={htmlBlurb}
          previousBtn="/recruitment-process"
          nextBtn="/training"
          mainContent={<MainContent />}
        />
      </div>
    </div>
  );
};

export default NewExpertOrientationPage;
